import styled from '@emotion/styled';

import { colors, gutter } from '../../../app/styles/constants';

export default styled.hr`
  border: 1px dashed ${colors.border};
  height: 0;
  margin: ${gutter} -${gutter};
`;
